module.exports = __webpack_public_path__ + "img/item2-4.2b4be15d.jpg";